var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_7_323)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.766 4.56588C22.4006 4.41367 21.9981 4.37366 21.6099 4.45094C21.2217 4.52823 20.8653 4.71932 20.586 4.99988L18 7.58588L13.414 2.99988C13.0389 2.62494 12.5303 2.41431 12 2.41431C11.4697 2.41431 10.9611 2.62494 10.586 2.99988L6 7.58588L3.414 4.99988C3.1343 4.72026 2.77797 4.52985 2.39006 4.45271C2.00216 4.37558 1.60009 4.41518 1.23469 4.56652C0.869291 4.71786 0.556965 4.97414 0.337197 5.30296C0.117428 5.63178 8.44486e-05 6.01838 0 6.41388L0 16.9999C0.00158786 18.3255 0.528882 19.5963 1.46622 20.5337C2.40356 21.471 3.67441 21.9983 5 21.9999H19C20.3256 21.9983 21.5964 21.471 22.5338 20.5337C23.4711 19.5963 23.9984 18.3255 24 16.9999V6.41388C24.0001 6.01835 23.8829 5.63167 23.6633 5.30273C23.4436 4.97379 23.1314 4.71737 22.766 4.56588Z",
    fill: "#191F30"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_323"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.1bb10b15ac1f966ea37e1a904239be59.svg";
export { ForwardRef as ReactComponent };